module.exports = __webpack_public_path__ + "static/media/whatsapp-icon.47d8cd4a.svg";